import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {QUERY_KEYS} from "./queryKeys";
import Api from "../api/Api";
import {IResult} from "../types/api";

export default function useGetPreCheckoutCheckQuery(): UseQueryResult<IResult<any>, Error> {
  return useQuery<IResult<any>, Error>({
    queryKey: [QUERY_KEYS.cart.preCheckoutCheck],
    queryFn: async () => {
      try {
        return await Api.preCheckout.preCheckoutCheck();
      } catch (error) {
        console.error('Error fetching pre-checkout check:', error);
        throw error;
      }
    }
  });
}
